/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';

import ConfirmDialog from 'components/ConfirmDialog';
import ErrorReporter from 'app/components/ErrorReporter';
import EventTracking from 'lib/EventTracking';

type Props = {
  orgUuid: ?string,
  orgName: ?string,
  onConfirm: Function,
  onRequestHide: () => void,
  filters: MessageFilterType[],
  totalRecipientCount: number,
  eventProperties?: any,
};

class SendToDistrictConfirmDialog extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey('announcements.composer.confirm_send.view', {
      organization_uuid: this.props.orgUuid,
      ...this.props.eventProperties,
    });
  }

  render() {
    const { totalRecipientCount, onConfirm, onRequestHide, orgName, orgUuid } = this.props;

    if (!orgUuid) {
      return (
        <ErrorReporter error="Tried to render SendToDistrictConfirmDialog without an orgUuid" />
      );
    }

    if (!orgName) {
      return (
        <ErrorReporter error="Tried to render SendToDistrictConfirmDialog without an orgName" />
      );
    }
    const secondaryText = `This announcement will be sent to ${totalRecipientCount} people in ${orgName}`;
    return (
      <ConfirmDialog
        title={<span>{secondaryText}</span>}
        onConfirm={onConfirm}
        onRequestHide={onRequestHide}
        data-test-selector="visual_composer_send_button"
        actionButtonText="Send"
        confirmEventKey="announcements.composer.confirm_send.send.click"
        confirmEventProperties={{
          ...this.props.eventProperties,
          organization_uuid: orgUuid,
        }}
        cancelButtonText="Cancel"
        cancelEventKey="announcements.composer.confirm_send.cancel.click"
        cancelEventProperties={{
          ...this.props.eventProperties,
          organization_uuid: orgUuid,
        }}
      />
    );
  }
}

const mapStateToProps = (state: Object) => {
  return {
    totalRecipientCount: state.roleBasedMessagingSearch.totalRecipientCount,
  };
};

export { SendToDistrictConfirmDialog };
export default connect(mapStateToProps)(SendToDistrictConfirmDialog);
